module.exports = __webpack_public_path__ + "img/03.cdc55152.png";